import React, { Component } from 'react'

import { formatHTML } from './format'

import './css/content.css'

window.toggleBrightness = function(node) {
  while (!node.classList.contains('content')) {
    node = node.parentNode
  }
  node.classList.toggle('content-bright')
}

export default class Content extends Component {

  state = {
    footnote  : null,
    footnoteT : 0,
    footnoteL : 0,
  }

  componentDidMount() {
    this.load(this.props)
  }

  componentWillReceiveProps(props) {
    this.load(props)
  }

  load(props) {
    this.setState({collapsed: this.props.moreHint && this.collapsible.offsetHeight >= 20})
  }

  extend() {
    this.setState({collapsed: false})
  }

  toggleFootnote(e) {
    let node = e.target
    while (node.parentElement) {
      if (node.className === 'content-footnote') {
        return
      }
      node = node.parentElement
    }
    if (e.target.tagName !== 'SUP' || this.state.footnote) {
      this.setState({footnote: null})
    } else {
      let T = e.target.offsetTop, L = e.target.offsetLeft, W = e.target.offsetWidth
      this.setState({footnote: e.target.getAttribute('data-footnote')}, () => {
        T -= this.footnote.offsetHeight + 5
        if (L + this.footnote.offsetWidth > document.getElementById('main').offsetWidth) {
          L -= this.footnote.offsetWidth + W
        } else {
          L += W
        }
        this.setState({footnoteT: T, footnoteL: L})
      })
    }
  }

  render() {
    let brightness = this.props.brightnessHint && `<span title="${this.props.brightnessHint}" onClick="toggleBrightness(this)" class="content-brightness-switch">A</span>`
    return !this.props.text ? '' : (
      <div
        ref       = {content => {this.content = content }}
        onClick   = {this.toggleFootnote.bind(this)}
        className = "content">
          <div
            ref       = {collapsible => { this.collapsible = collapsible }}
            className = {this.state.collapsed ? 'content-collapsed' : ''}>
              <div dangerouslySetInnerHTML = {{__html: formatHTML(this.props.text, {extra: brightness})}} />
              <div
                ref       = {more => { this.more = more }}
                onClick   = {this.extend.bind(this)}
                className = "link content-more"
                style     = {{display: this.state.collapsed ? 'block' : 'none'}}>{this.props.moreHint}</div>
        </div>
        <div dangerouslySetInnerHTML={{__html: formatHTML(this.state.footnote)}}
          ref       = {footnote => { this.footnote = footnote }}
          className = "content-footnote"
          style     = {{
            visibility : this.state.footnote ? 'visible' : 'hidden',
            top        : this.state.footnoteT,
            left       : this.state.footnoteL,
          }}
        />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/content.js